import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FloatingGetApp.css';

const APP_STORE_URL = 'https://apps.apple.com/in/app/roam4less-esim-travel-data/id6756699233';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.roam4less.app&hl=en_IN';

function FloatingGetApp() {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        type="button"
        className="floating-get-app-pill-btn"
        onClick={() => setShowModal(true)}
        aria-label={t('Get the app', 'Get the app')}
      >
        <span>{t('Get the app', 'Get the app')}</span>
        <span className="floating-arrow-icon">→</span>
      </button>

      {/* App Download Modal */}
      {showModal && (
        <div className="floating-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="floating-modal-card" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="floating-modal-close"
              onClick={() => setShowModal(false)}
              aria-label="Close"
            >
              &times;
            </button>
            <h3>{t('appDownloadModal.title', 'Download the Roam4Less App')}</h3>
            <p>
              {t(
                'appDownloadModal.description',
                'Download our app to easily manage your eSIMs, check real-time data usage, and top up anytime on the go.'
              )}
            </p>
            <div className="floating-modal-stores">
              <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
                <img src={window.getPublicUrl('images/app-store.png')} alt="App Store" />
              </a>
              <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
                <img src={window.getPublicUrl('images/google-play.png')} alt="Google Play" />
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FloatingGetApp;
